import {request} from "../../Base/HTTP";

export async function getSiteData() {
    return await request('/api/default/site-data');
}